import { Button, Space } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UploadExcelModal from "../../../../components/common/UploadExcelModal";
import { useUploadVariableSalaryMutation } from "../../../../features/emp-setting/employee/employeeApi";
import useError from "../../../../hooks/useError";
import { toast } from "../../../../lib/toast";
import { ModalComponentProps } from "../../../../types";

export default function VariableSalaryModal({
  open,
  handleClose,
}: ModalComponentProps) {
  const navigate = useNavigate();
  const [uploadVariableSalary, { isLoading, isError, error, isSuccess }] =
    useUploadVariableSalaryMutation();
  useError(isError, error, "Upload variable salary fail");
  const [formData, setFormData] = useState<FormData | null>(null);

  // success toast message
  useEffect(() => {
    if (isSuccess) {
      toast("success", "Variable salary updated successfully");
      navigate("/admin/payroll/variable-salary");
      return handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, navigate]);

  return (
    <UploadExcelModal
      open={open}
      handleClose={handleClose}
      isLoading={false}
      handler={setFormData}
      title="Update Variable Salary Data in Bulk"
      warningText="Please enter the year as a four-digit number (e.g., 2025, 2024) and the month as a number (e.g., 1 for January, 12 for December)."
      downloadLink={"/sample-variable-salary.xlsx"}
      footer={
        <Space size={12}>
          <Button
            className="modal-button"
            type="primary"
            loading={isLoading}
            onClick={() => uploadVariableSalary(formData)}
          >
            Upload
          </Button>
        </Space>
      }
    />
  );
}
